{
  "panel": {
    "title": "Asistente Xtreed",
    "subtitle": "Arma tus cursos por ti",
    "close": "Contraer asistente",
    "newConversation": "Nueva conversación",
    "conversations": "Conversaciones",
    "noConversations": "Aún no hay conversaciones",
    "untitled": "Nueva conversación",
    "deleteConversation": "Eliminar conversación",
    "deleteConfirm": "¿Eliminar esta conversación? Los cursos creados siguen en tu área de miembros.",
    "loadOlder": "Cargar mensajes anteriores"
  },
  "empty": {
    "title": "¿Armamos tu curso?",
    "description": "Cuéntame sobre el curso y envía los videos o enlaces. Organizo módulos y clases, tú apruebas y yo subo todo a tu área de miembros.",
    "suggestions": {
      "newCourse": "Armar un curso nuevo",
      "newCoursePrompt": "Quiero armar un curso nuevo en mi área de miembros.",
      "addModule": "Agregar un módulo a un curso",
      "addModulePrompt": "Quiero agregar un módulo a un curso que ya existe.",
      "status": "Ver mis cursos",
      "statusPrompt": "¿Qué cursos tengo en mi área de miembros?"
    },
    "context": {
      "title": "En este curso",
      "review": "Revisar la estructura de este curso",
      "reviewPrompt": "Revisa la estructura del curso que estoy viendo y dime qué falta para que quede listo.",
      "describe": "Escribir descripciones",
      "describePrompt": "Escribe descripciones para el curso que estoy viendo y sus módulos.",
      "publish": "Publicar este curso",
      "publishPrompt": "Quiero publicar el curso que estoy viendo. Revisa si falta algo antes."
    }
  },
  "composer": {
    "label": "Mensaje para el asistente",
    "placeholder": "Describe el curso o pega enlaces…",
    "placeholderRunning": "El asistente está respondiendo…",
    "send": "Enviar",
    "stop": "Detener",
    "attach": "Adjuntar videos, imágenes o materiales",
    "dropHere": "Suelta los archivos para enviarlos",
    "removeAttachment": "Quitar adjunto"
  },
  "message": {
    "typing": "El asistente está escribiendo",
    "aborted": "Respuesta interrumpida.",
    "error": "No pude terminar esta respuesta. Inténtalo de nuevo."
  },
  "tools": {
    "get_member_area_overview": "Consultando tus cursos",
    "get_course_tree": "Leyendo la estructura del curso",
    "apply_course_plan": "Armando el curso",
    "create_course": "Creando el curso",
    "update_course": "Actualizando el curso",
    "create_module": "Creando módulo",
    "update_module": "Actualizando módulo",
    "reorder_modules": "Reordenando módulos",
    "create_lesson": "Creando clase",
    "update_lesson": "Actualizando clase",
    "reorder_lessons": "Reordenando clases",
    "move_lesson": "Moviendo clase",
    "set_lesson_video_embed": "Vinculando video por enlace",
    "attach_uploaded_video": "Vinculando video subido",
    "set_course_image": "Definiendo imagen del curso",
    "add_lesson_material": "Agregando material",
    "get_upload_status": "Revisando los envíos",
    "set_course_visibility": "Ajustando visibilidad",
    "publish_course": "Publicando el curso",
    "delete_course": "Eliminando el curso",
    "delete_module": "Eliminando módulo",
    "delete_lesson": "Eliminando clase",
    "unlink_module": "Quitando módulo del curso",
    "unlink_lesson": "Quitando clase del módulo",
    "get_member_area_link": "Buscando el enlace",
    "archive_course": "Archivando el curso",
    "get_course_sales_status": "Revisando la venta del curso",
    "set_module_image": "Definiendo imagen del módulo",
    "list_course_sections": "Consultando la vitrina",
    "create_course_section": "Creando sección de la vitrina",
    "add_course_to_section": "Poniendo el curso en la vitrina",
    "remove_course_from_section": "Quitando el curso de la sección",
    "list_categories": "Consultando categorías",
    "create_category": "Creando categoría",
    "set_course_category": "Definiendo categoría",
    "fallback": "Trabajando"
  },
  "approval": {
    "title": "Necesito tu confirmación",
    "approve": "Aprobar",
    "reject": "No hacerlo",
    "adjust": "Pedir ajuste",
    "adjustPlaceholder": "¿Qué quieres cambiar?",
    "sendAdjust": "Enviar ajuste",
    "cancel": "Cancelar",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "edited": "Aprobado con cambios",
    "expired": "Esta confirmación expiró",
    "actions": {
      "publish_course": "Publicar el curso en el área de miembros",
      "set_course_visibility": "Cambiar la visibilidad de un curso publicado",
      "delete_course": "Eliminar un curso",
      "delete_module": "Eliminar un módulo",
      "delete_lesson": "Eliminar una clase",
      "unlink_module": "Quitar un módulo del curso",
      "unlink_lesson": "Quitar una clase del módulo",
      "archive_course": "Sacar el curso del aire (archivar)",
      "fallback": "Ejecutar una acción"
    },
    "visibilityTo": "Nueva visibilidad: {{value}}"
  },
  "plan": {
    "title": "Propuesta de estructura",
    "existingCourse": "Nuevos módulos para un curso existente",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "lessons_one": "{{count}} clase",
    "lessons_zero": "{{count}} clases",
    "lessons_other": "{{count}} clases",
    "videoLink": "Video por enlace",
    "videoUpload": "Video subido",
    "noVideo": "Sin video",
    "free": "Gratis",
    "visibility": {
      "HIDDEN": "Oculto para quien no compró",
      "LOCKED": "Visible con candado"
    },
    "editHint": "Puedes editar los títulos antes de aprobar.",
    "moduleLabel": "Módulo {{index}}"
  },
  "uploads": {
    "title": "Archivos",
    "status": {
      "PENDING": "En espera",
      "UPLOADING": "Subiendo",
      "UPLOADED": "Recibido",
      "PROCESSING": "Procesando",
      "READY": "Listo",
      "FAILED": "Falló"
    },
    "retry": "Intentar de nuevo",
    "pickAgain": "Seleccionar el archivo de nuevo",
    "linked": "Vinculado a una clase"
  },
  "errors": {
    "runFailed": "No fue posible hablar con el asistente.",
    "createConversation": "No fue posible abrir la conversación.",
    "deleteConversation": "No fue posible eliminar la conversación.",
    "upload": "No fue posible subir {{name}}.",
    "loadHistory": "No fue posible cargar la conversación."
  }
}
